import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();
  return {
    tabsOffset: {
      margin: theme.spacing(-1, -2, 0, -2),
    },
    tabs: {
      padding: '10px',
      background: 'white',
      cursor: 'pointer',
      border: 'none',
      fontSize: '16px',
      fontWeight: 'bold',
      borderRadius: '4px 4px 0 0',
      marginRight: '6px',
      borderBottom: 'none',
    },
    activeTabs: {
      padding: '10px',
      background: 'white',
      marginBottom: '-1px',
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      borderBottom: '3px solid #05A4D8 !important',
      marginRight: '6px',
      fontSize: '16px',
      fontWeight: 'bold',
      borderRadius: '4px 4px 0 0',
    },
    activeContent: {
      display: 'block',
      background: 'white',
      padding: '20px',
      width: '100%',
      height: '100%',
      overflow: 'auto',
    },
    content: {
      display: 'none',
      background: 'white',
      padding: '10px',
      width: '100%',
      height: '100%',
      overflow: 'auto',
    },
    contentTabs: {
      flexGrow: 1,
    },
    sfHR: {
      borderTop: 'solid 1px #D6D6D6',
      margin: '25px 0 25px 0',
    },
  };
};
